import React, { useState } from 'react';
import { KTSVG } from '../../../_metronic/helpers';

type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';
type TooltipTheme = 'light' | 'dark';

interface GenericTooltipProps {
    title: string;
    message: string;
    position?: TooltipPosition;
    iconPath?: string;
    theme?: TooltipTheme;
    className?: string;
    classNameChild?: string;
}

const GenericTooltip: React.FC<GenericTooltipProps> = ({
    title,
    message,
    position = 'top',
    iconPath,
    theme = 'dark',
    className,
    classNameChild,
}) => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className={`generic-tooltip-wrapper position-relative d-inline-block`}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {/* Trigger */}
            <span className={`tap-host-secction-experiences-past-info-text align-items-center gap-1 ${className ? `${className}` : ''}`}>
                {title}
                {iconPath ? (<KTSVG path={iconPath} />) : (null)}
            </span>

            {/* Tooltip */}
            {open && (
                <div className={`generic-tooltip-card generic-tooltip-${position} generic-tooltip-${theme} ${classNameChild ? `${classNameChild}` : ''}`}>
                    {message}
                </div>
            )}
        </div>
    );
};

export default GenericTooltip;
